<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card>
                    <div slot="header">
                        <strong>Incident Master</strong>
                    </div>

                    <div>
                        <b-row>
                            <b-col>
                                <b-card bg-variant="primary" text-variant="light">
                                    <router-link tag="li" class="pointer" :to="{ name: 'open_incident'}">
                                        <b-card-text class="text-center">
                                            <h3>{{incident_count.open_count}}</h3>
                                            <h5>OPEN INCIDENTS</h5>
                                        </b-card-text>
                                    </router-link>
                                </b-card>
                            </b-col>
                            <b-col>
                                <b-card bg-variant="success" text-variant="light">
                                    <router-link tag="li" class="pointer" :to="{ name: 'approve_incident'}">
                                        <b-card-text class="text-center">
                                            <h3>{{incident_count.approved_count}}</h3>
                                            <h5>APPROVED INCIDENTS</h5>
                                        </b-card-text>
                                    </router-link>
                                </b-card>
                            </b-col>
                            <b-col>
                                <b-card bg-variant="danger" text-variant="light">
                                    <router-link tag="li" class="pointer" :to="{ name: 'rejected_incident'}">
                                        <b-card-text class="text-center" >
                                            <h3>{{incident_count.rejected_count}}</h3>
                                            <h5>REJECTED INCIDENTS</h5>
                                        </b-card-text>
                                    </router-link>
                                </b-card>
                            </b-col>
                            <b-col>
                                <b-card bg-variant="warning" text-variant="light">
                                    <router-link tag="li" class="pointer" :to="{ name: 'other_incident'}">
                                        <b-card-text class="text-center">
                                            <h3>{{incident_count.other_count}}</h3>
                                            <h5>OTHER INCIDENTS</h5>
                                        </b-card-text>
                                    </router-link>
                                </b-card>
                            </b-col>
                        </b-row>
                    </div>

                    <div>
                        <b-row>
                            <b-col sm="2">
                                <router-link to="/incident_listing">
                                    <b-button variant="primary">Incident Listing</b-button>
                                </router-link>
                            </b-col>
                            <b-col sm="2">
                                <router-link to="/report_incident">
                                    <b-button variant="primary">Report a Incident</b-button>
                                </router-link>
                            </b-col>
                            <b-col sm="5">
                                <b-form-group label-cols="3" label="Select Vehicle : " class="mb-0">
                                    <ejs-multiselect  id='multi_select2'  placeholder="Select Vehicle Number" v-model="valueVehicle" :dataSource='optionsVehicle' :showSelectAll='showVehicleSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldVehicle' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                    ></ejs-multiselect>
                                    <!-- <b-input-group>
                                      <b-form-input v-model="filter" placeholder="Enter Vehicle number"></b-form-input>
                                      <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                      </b-input-group-append>
                                    </b-input-group> -->
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row class="mt-4 align-items-center">
                        <!-- Incident Level Selection -->
                        <b-col md="4">
                            <b-form-group label="Select Incident Level:" :label-cols="6">
                                <b-form-checkbox-group v-model="selected_levels" class="mt-1">
                                    <b-form-checkbox value="hub" switch class="custom-checkbox mb-1">Hub Level</b-form-checkbox>
                                    <b-form-checkbox value="vehicle" switch class="custom-checkbox">Vehicle Level</b-form-checkbox>
                                </b-form-checkbox-group>
                            </b-form-group>

                        </b-col>

                        <!-- Hub Selection -->
                        <b-col md="4">
                            
                            <b-form-group label="Select Hubs:" :label-cols="4">

                                                    <div id='container'>
                                                        <ejs-multiselect  id='multi_select2'  placeholder="Select Hub Name" v-model="valueWH" :dataSource='optionsWH' :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='fieldWH' :allowCustomValue='allowCustomValue'  enableGroupCheckBox="true" mode="CheckBox" 
                                                        ></ejs-multiselect>
                                                    </div>
                                                </b-form-group>
                            <!-- <b-form-select v-model="selectedhub">
                                <option :value="null">-- Select Hub --</option>
                                <option :value="hub.hubid" v-for="hub in hubItems" :key="hub.hubid">
                                {{ hub.hubname }} - {{ hub.hubid }}
                                </option>
                            </b-form-select> -->
                        </b-col>

                        <!-- Buttons -->
                        <b-col md="2">
                            <b-button size="md" variant="primary" @click.prevent="ReportcountList()">Search</b-button>
                            &nbsp;
                            <b-button size="md" variant="danger" @click.prevent="ReportClearList()">Clear</b-button>
                        </b-col>
                        </b-row>

                        <b-row mt="2" class="d-flex justify-content-end">
                            <b-col md="2">
                            <div class="">
                            <h6><b>Total Records: <span style="color: red;">{{ totalRows }}</span></b></h6>
                            </div>
                        </b-col>
                        </b-row>

                    <div>
                        
                        <b-table responsive :fields="fields" :items="vehicle_count" :filter="filter" :busy="isBusy" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" caption-top>
                            {{ hubvehicle }}
                            <template slot="vehicle_no" slot-scope="row">
                                <div>
                                    {{ row.item.hubvehicle }}
                                </div>
                            </template>
                            <div slot="table-busy" class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                            <template #table-caption><b>Incidents Listed</b></template>
                        </b-table>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import auth from "@/utils/auth";
import Swal from 'sweetalert2';
export default {
    data() {
        return {
            incident_count :[],
            filter: null,
            fields : [ 
                { key : 'vehicle_no', label : 'Vehicle No / Hub Name'},
                { key : 'open_count', label : 'Open Incident'},
                { key : 'approved_count', label : 'Approve Incident'},
                { key : 'rejected_count', label : 'Rejected Incident'},
                { key : 'other_count', label : 'Other Incident'},
            ],
            vehicle_count : [],
            totalRows :0,
            isBusy : false,
            selectedhub:'',
            select :'',
            selectedhubvalue :'',
            hubItems:[],
            optionsWH:[],
            WHData:[],
            showSelectAll : true,
            valueWH:[],
            fieldWH:{ text: 'name', value: 'id' },
            optionsVehicle:[],
            VehicleData:[],
            valueVehicle: [],
            showVehicleSelectAll : true,
            fieldVehicle:{ text: 'name', value: 'id' },
            accessBody:[],
      isReadOnly:false,
        }
    },

    created() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        console.log("userInfo",userInfo)
        this.accessBody = userInfo.body;
    console.log("--------->>>>>>>>>>",userInfo.body)
    this.ischeckbodyvalidation();
        this.hubListing();
        
        
    },
    mounted(){
        this.showWHlist();
        this.Vehicledata();
        this.ReportcountList();
        this.dashboardList();
    },

    methods: {
        ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Bulk Reallocation' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Bulk Reallocation' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
        dashboardList : function () {
            this.incident_count = [];
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
        
            const obj = {};

            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/incidentReportCount`,obj).then(result => {
                document.getElementById("overlay").style.display = "none";
                if (result.body.returnmsg === 'Successful') {
                    this.incident_count = result.body.returnvalue[0];
                } else {
                    this.incident_count = [];
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
        },

        ReportcountList : function () {        
            this.vehicle_count = [];
            this.totalRows = 0;
            this.isBusy = true;
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            let incidentArr2 = []
            if ((this.selected_levels && this.selected_levels.length === 2)){
                incidentArr2 = this.selected_levels
            }
            if ((this.selected_levels && this.selected_levels.length > 1 || this.selected_levels && this.selected_levels.length === 0) && (this.selected_levels && this.selected_levels.length !== 1)) {
                this.selected_levels = null
            }
            if (this.selected_levels && this.selected_levels.length === 1) {
                this.selected_levels = this.selected_levels.toString()   
            }

            const filterObj = { 
            incidentlevel: this.selected_levels && this.selected_levels.length === 0 ? null : this.selected_levels,
            hubid: this.valueWH && this.valueWH.length === 0 ? null : this.valueWH,
            // report_status: "open",
            vehicleid: this.valueVehicle && this.valueVehicle.length === 0 ? null : this.valueVehicle
            };
            
            // return false
            this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/getIncidentDashboard`,filterObj).then(result => {
                console.log("res",result)
                this.isBusy = false;
                if (result.body.returnmsg === 'Successful') {
                    this.vehicle_count = result.body.returnvalue;
                    this.totalRows = result.body.returnvalue.length;
                    if (this.selected_levels === null) {
                        this.selected_levels = [];
                    }
                    if (this.selected_levels && this.selected_levels.length !== 0) {
                        this.selected_levels = this.selected_levels && this.selected_levels.split(',');
                    }
                    if (this.selected_levels && this.selected_levels.length === 0) {
                        this.selected_levels =  incidentArr2
                    }
                    
                    // console.log( this.totalRows)
                } else {
                    this.selected_levels = [],
                    this.valueWH = [],
                    this.valueVehicle = []
                    // this.ReportcountList()
                    return Swal.fire({
                        title: result.body.returnvalue,
                        icon: 'error',
                    })
                }
            })
            .catch((ex) => {
                console.log("error", ex);
            });
            
        },

        hubListing(){
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj={
        sysusermasterid:`${userInfo.sysusermasterid}`,
        usertype : `${userInfo.user_type}`,
      }
      console.log("objlist",obj)
      this.$http
            .post(
              `${ CONSTANTS.MIGRATION_API_URL}/getAllHubListing`,obj).then(result => {
                if (result.body.returnmsg === "Successful") {
                 this.hubItems=result.body.returnvalue;
                 console.log("aaaaaaaa",this.hubItems);
                 
                }else{
                  this.hubItems=[];
                }
              }).catch(ex => {
              console.log("error", ex);
            });
      },

      showWHlist:function(){
          
          var userdata = localStorage.getItem('userData')
          var userInfo = JSON.parse(userdata)
          
          var csvObj = {
              sysusermasterid:`${userInfo.sysusermasterid}`,
              usertype:`${userInfo.user_type}`
          };
          this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getAllHubListing`, csvObj)
            .then(result => {
              
              if (result.body.returnmsg === 'Successful') {
                  this.optionsWH=[];
              
                  this.WHData  = result.body.returnvalue;
                  
                  for(let j = 0; j < this.WHData.length; j++) {
                      let WH = {
                      name: this.WHData[j].hubname + " - " + this.WHData[j].hubid,
                      id: this.WHData[j].hubid,
                      }
                  this.optionsWH.push(WH);
                  }
              
              } else {              
                  this.WHData  = result.body.returnvalue;
              }
          

          })
          .catch(ex => {
              console.log("error-----", ex);
          });
      },

      ReportClearList() {
        this.selected_levels = [],
        this.valueWH = [],
        this.valueVehicle = []
        this.ReportcountList();
      },

      Vehicledata: function() {
        
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);
            this.vehicleitems=[];
            const deliveryagentobj = {};
            console.log('deliveryagentobj',deliveryagentobj);
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/incidentVehicleListing`,deliveryagentobj
            )
            .then(result => {
            console.log("YYY",result);
            if (result.body.returnmsg === "Successful") {
                this.optionsVehicle=[];
              
              this.VehicleData  = result.body.returnvalue;
              
              for(let j = 0; j < this.VehicleData.length; j++) {
                  let WH = {
                  name: this.VehicleData[j].vehicle_no + " - " + this.VehicleData[j].vehicle_id,
                  id: this.VehicleData[j].vehicle_id,
                  }
              this.optionsVehicle.push(WH);
              }
                }else{
                    this.VehicleData  = result.body.returnvalue;
                }
            })
            .catch(ex => {
            console.log("error", ex);
            });
        
        },

    //   searchList: function () {
    //     this.isBusy = true;
    //         var userdata = localStorage.getItem("userData");
    //         var userInfo = JSON.parse(userdata);
        
    //         const filterObj = { 
    //         incidentlevel: this.selected_levels.toString(),
    //         hubid: this.valueWH,
    //         report_status: "open",
    //         vehicle_id: this.filter ? [...this.filter] : []
    //         };

    //         // return false
    //         this.$http.post(`${ CONSTANTS.MIGRATION_API_URL}/incidentReportList`,filterObj).then(result => {
    //             console.log("res",result)
    //             this.isBusy = false;
    //             if (result.body.returnmsg === 'Successful') {
    //                 this.vehicle_count = result.body.returnvalue;
    //                 console.log("incident_count",this.incident_count)
    //                 this.totalRows = result.body.returnvalue.length;
    //                 // console.log( this.totalRows)
    //             } else {
    //                 this.vehicle_count = result.body;
    //                 console.log(this.vehicle_count, 'this.vehicle_count');
    //                 this.totalRows = result.body.length;
    //             }
    //         })
    //         .catch((ex) => {
    //             console.log("error", ex);
    //         });
    //   }

    },
}
</script>

<style scoped>
.pointer {
    cursor: pointer;
}
.custom-checkbox .custom-control-label {
  position: relative;
  padding-left: 2rem; /* Adjust this to fit the size of your checkbox */
  cursor: pointer;
}

.custom-checkbox .custom-control-label::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 20px; /* Adjust the size of the checkbox */
  height: 20px;
  border: 2px solid #007bff; /* Border color */
  border-radius: 50%; /* Makes it circular */
  background-color: #fff; /* Background color */
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #007bff; /* Background color when checked */
  border-color: #007bff; /* Border color when checked */
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 5px; /* Adjust positioning of the checkmark */
  transform: translateY(-50%);
  width: 10px; /* Adjust size of the checkmark */
  height: 10px;
  border-radius: 50%; /* Checkmark shape */
  background-color: #fff; /* Checkmark color */
}

</style>